import { FC } from 'react'

import styled from 'styled-components'

import { MAX_TABLET_WIDTH } from '../../../../Styled/variables'
import { SimpleLabel } from '../../../SimpleLabel'

import { getBadgesData } from './helpers'

interface BadgesBlockProps {
  matchingPercent?: number
  madePlacements?: boolean
  isSaved?: boolean
  lastActivity?: string | Date
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  flex: 1;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    flex: unset;
    padding-left: 70px;
    width: 100%;
  }
`

export const BadgesBlock: FC<BadgesBlockProps> = ({
  matchingPercent,
  madePlacements,
  isSaved,
  lastActivity,
}) => {
  const { showTopMatch, activityBadge, hasAnyBadge } = getBadgesData(
    matchingPercent,
    madePlacements,
    isSaved,
    lastActivity,
  )

  if (!hasAnyBadge) {
    return null
  }

  return (
    <Container>
      {showTopMatch && <SimpleLabel color='green'>Top Match</SimpleLabel>}
      {madePlacements && (
        <SimpleLabel color='green'>Supported you before</SimpleLabel>
      )}
      {isSaved && <SimpleLabel color='green'>Saved curator</SimpleLabel>}
      {activityBadge && (
        <SimpleLabel color={activityBadge.isRecent ? 'green' : 'grey'}>
          {activityBadge.label}
        </SimpleLabel>
      )}
    </Container>
  )
}
